class StExtrasController {
    constructor($translate, $filter) {
        'ngInject';
        this.name = 'stExtras';
        this.$translate = $translate;
        this.$filter = $filter;
    }

    $onInit() {
        this.translations = this.$translate.instant([
            "title_col1",
            "title_col2",
            "title_col2b",
            "title_col3",
            "title_col4",
            "1_description",
            "2_description",
            "3_description",
            "4_description",
            "5_description",
            "6_description",
            "7_description",
            "8_description",
            "extras_price_zero"
        ]);

        //TODO Clean up when we have correct segment
        angular.merge(this.translations, this.$filter('splitTranslationWithLink')('extras_price_zero', {
            link_start: '<a>',
            link_end: '</a>'
        }));

        this.translations.n_transfer_extras = this.$translate.instant("n_transfer_extras", {
            n: this.index
        });

    }

    range(num) {
        // return [...Array(1 + num).keys()].map(v => v);
        let arr = new Array(num + 1);
        for (let i = 0; i < arr.length; i++) {
            arr[i] = i;
        }
        return arr;
    }

    openChat() {
        const chat = document.querySelector('.inbenta-launcher');
        if (chat) {
            chat.click();
        } else if (!document.querySelector('.inbenta-avatar')) {
            zE.activate();
        }
        return false;
    }
}

export default StExtrasController;



// WEBPACK FOOTER //
// ./client/app/common/stExtras/stExtras.controller.js